// Use window.DOMParser to parse xml

export const parseXml = (xml) => {
  const parser = new DOMParser()
  return parser.parseFromString(xml, 'text/xml')
}
